import { _ as __rest } from '../tslib.es6-c563c1dd.js';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { alpha } from '@mui/material';

const PREFIX = 'Label';
const classes = {
    root: `${PREFIX}-root`,
    primary: `${PREFIX}-primary`,
    secondary: `${PREFIX}-secondary`,
    error: `${PREFIX}-error`,
    success: `${PREFIX}-success`,
    warning: `${PREFIX}-warning`,
    info: `${PREFIX}-info`,
};
const Root = styled('span')(({ theme }) => ({
    [`&.${classes.root}`]: {
        fontFamily: theme.typography.fontFamily,
        alignItems: 'center',
        borderRadius: 2,
        display: 'inline-flex',
        flexGrow: 0,
        whiteSpace: 'nowrap',
        cursor: 'default',
        flexShrink: 0,
        fontSize: theme.typography.pxToRem(12),
        fontWeight: theme.typography.fontWeightMedium,
        height: 20,
        justifyContent: 'center',
        letterSpacing: 0.5,
        minWidth: 20,
        padding: theme.spacing(0.5, 1),
        textTransform: 'uppercase',
    },
    [`&.${classes.primary}`]: {
        color: theme.palette.primary.main,
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
    [`&.${classes.secondary}`]: {
        color: theme.palette.secondary.main,
        backgroundColor: alpha(theme.palette.secondary.main, 0.08),
    },
    [`&.${classes.error}`]: {
        color: theme.palette.error.main,
        backgroundColor: alpha(theme.palette.error.main, 0.08),
    },
    [`&.${classes.success}`]: {
        color: theme.palette.success.main,
        backgroundColor: alpha(theme.palette.success.main, 0.08),
    },
    [`&.${classes.warning}`]: {
        color: theme.palette.warning.main,
        backgroundColor: alpha(theme.palette.warning.main, 0.08),
    },
    [`&.${classes.info}`]: {
        color: theme.palette.info.main,
        backgroundColor: alpha(theme.palette.info.main, 0.08),
    },
}));
const Label = (_a) => {
    var { className, color = 'secondary', children } = _a, rest = __rest(_a, ["className", "color", "children"]);
    return (jsx(Root, Object.assign({ className: clsx(classes.root, {
            [classes[color]]: color,
        }, className) }, rest, { children: children })));
};

export { Label };
